import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box, Typography } from "@mui/material";

export default function Selection({ label, value, onChange, options }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography>{label}</Typography>
      <FormControl
        variant="outlined"
        sx={{
          mx: 1,
          width: "80%",
          "& .MuiInputBase-root": {
            mt: 0,
          },
        }}
      >
        <Select
          value={value}
          onChange={onChange}
          sx={{
            "& .MuiSelect-select": {
              py: 1,
              px: 2,
            },
          }}
        >
          {options.map((opt) => {
            return (
              <MenuItem value={opt} key={opt}>
                {opt}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
}
